import config from '@/config';
import type { AppModule } from '@/config/maintenanceModules';
import { useDeploymentSettingsStore } from '@/stores/deploymentSettings';
import { canUserAccessModuleFully } from '@/utils/moduleAccess';

export interface MenuItem {
    label: string;
    icon?: string;
    to?: string;
    name?: string;
    url?: string;
    class?: string;
    target?: string;
    visible?: boolean;
    requiresAuth?: boolean;
    allowedUsers?: number[];
    items?: MenuItem[];
}

export function isMenuItemVisibleForUser(
    item: MenuItem,
    userType: number,
    email?: string
): boolean {
    if (item.allowedUsers && !item.allowedUsers.includes(userType)) {
        return false;
    }

    const store = useDeploymentSettingsStore();

    if (item.items?.length) {
        const visibleChildren = item.items.filter((child) =>
            isMenuItemVisibleForUser(child, userType, email)
        );
        return visibleChildren.length > 0;
    }

    if (!item.name) {
        return true;
    }

    if (item.name === 'deployment-settings' || item.name === 'login-history') {
        return userType === config.userType.admin;
    }

    if (
        item.name &&
        !canUserAccessModuleFully(item.name as AppModule, userType, email, store)
    ) {
        return false;
    }

    return true;
}

export function filterMenuItems(
    items: MenuItem[],
    userType: number,
    email?: string
): MenuItem[] {
    return items
        .filter((item) => isMenuItemVisibleForUser(item, userType, email))
        .map((item) => {
            if (!item.items?.length) {
                return item;
            }
            return {
                ...item,
                items: filterMenuItems(item.items, userType, email),
            };
        });
}
